module.exports = __webpack_public_path__ + "d67e599c2ea5245a3c6c97a6cb3949b7.png";